import { render, staticRenderFns } from "./成交公告详情_许昌版本.vue?vue&type=template&id=137e1576&scoped=true"
import script from "./成交公告详情_许昌版本.vue?vue&type=script&lang=js"
export * from "./成交公告详情_许昌版本.vue?vue&type=script&lang=js"
import style0 from "./成交公告详情_许昌版本.vue?vue&type=style&index=0&id=137e1576&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e1576",
  null
  
)

export default component.exports